import React from 'react'
import LocalPageTemplate from './templates/LocalPageTemplate'

function TemplateSwitch(props) {
  const { type } = props
  if (Object.keys(props).length !== 0)
    switch (type) {
      case 'local_page':
        return <LocalPageTemplate {...props} key={props.title} />
      default:
        console.warn(`No template found for ${type}\n`, props)
    }
}

export default TemplateSwitch
